// src/utils/toast.ts
import { PrinterConfig } from "../types/printerTypes";
import { Buffer } from "buffer";
import moment from "../utils/moment";
import columnify from "columnify";
import { pad } from "../utils/util";
import { ORDER_SERVICE } from "../recoil/type";
import {
  PRINTER_KNOCKKNOCK_LOGO_IMAGE,
  PRINTER_ORDER_ADULT_IMAGE,
} from "../components/PrinterImages";
import QRCode from "qrcode";
import {
  PrintBuffer,
  ESCPOSImage,
  BitmapDensity,
  BarcodeQROptions,
  QRLevel,
} from "../utils/PrinterHelper";

const convertPrinterBufferToString = (buffer: any) => {
  //let sData =
  let sRet = "";
  let aRet = [];
  if (buffer) {
    let aString = buffer.match(/.{1,2}/g);
    for (const sHex of aString) {
      aRet.push("0x" + sHex);
    }
    sRet = aRet.join(" ");
  }

  return sRet;
};

const posWhiteSpace = "\u2063";

const receiptWidth = 42;

const receiptFormat = {
  prd_w: 30,
  amount_w: 10,
  order_option_mark: "-> ",
  receipt_option_mark: "-> ",
};

const columnifyPrd = (aData: any) => {
  var sOrderDataList = columnify(aData, {
    truncate: false,
    truncateMarker: "",
    showHeaders: false,
    config: {
      prdname: { minWidth: 20, maxWidth: 20, showHeaders: false },
      price: { minWidth: 7, maxWidth: 7, align: "right", showHeaders: false },
      count: { minWidth: 4, maxWidth: 4, align: "right", showHeaders: false },
      amount: { minWidth: 8, maxWidth: 8, align: "right", showHeaders: false },
    },
  });

  return sOrderDataList + "\n";
};

const columnifySetPrd = (aData: any) => {
  var sOrderDataList = columnify(aData, {
    truncate: false,
    truncateMarker: "",
    showHeaders: false,
    config: {
      prdname: { minWidth: 33, maxWidth: 33, showHeaders: false },
      amount: { minWidth: 8, maxWidth: 8, align: "right", showHeaders: false },
    },
  });

  return sOrderDataList + "\n";
};

const columnifyKitchenPrd = (aData: any) => {
  var sOrderDataList = columnify(aData, {
    truncate: false,
    truncateMarker: "",
    showHeaders: false,
    config: {
      prdname: { minWidth: 30, maxWidth: 30, showHeaders: false },
      count: { minWidth: 10, maxWidth: 10, align: "right", showHeaders: false },
    },
  });

  return sOrderDataList + "\n";
};

const filterEmoticon = (sName: string) => {
  let sFiltered: string = sName;
  try {
    //sFiltered = sName.replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, '');
    //sFiltered = sName.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
    sFiltered = sName.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "");
  } catch (error) {}
  return sFiltered;
};

const append = (aBuffer: any, sBuffer: any) => {
  aBuffer.push(sBuffer);
  return aBuffer;
};

const toHexString = (ByteBuffer: any) => {
  return convertPrinterBufferToString(ByteBuffer.toString("hex"));
};

const addHeader = async (oOrderData: any) => {
  let aBuffer: any = [];
  let sDeliveryAddressDetail = "";
  let sDeliveryAddress = "주소: ";
  let sBillNumber = "주문번호: ";
  let sInquiry = "";
  let sCustomerPhone = "";
  let sCustomerAddress = "";

  if (oOrderData && oOrderData.child) {
    sDeliveryAddressDetail = oOrderData.child.delivery_address_detail;
    sDeliveryAddress += oOrderData.child.delivery_address;
    sBillNumber += oOrderData.child.bill_number;

    if (oOrderData.child.inquiry) {
      sInquiry = oOrderData.child.inquiry;
    }

    if (oOrderData.child.hotel_phone_number) {
      sCustomerPhone = `호텔전화(비상시만):`;
      sCustomerAddress = `${oOrderData.child.hotel_phone_number} (${oOrderData.child.delivery_address_detail})`;
    }
  }

  aBuffer = append(aBuffer, toHexString(PrinterConfig.HW_INIT));
  if (
    oOrderData &&
    oOrderData.child &&
    oOrderData.child.order_service === ORDER_SERVICE.KNOCKKNOCK_ORDER
  ) {
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_FONT_B));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_ALIGN_CT));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_2HEIGHT));
    aBuffer = append(aBuffer, '"KNOCK KNOCK"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
    aBuffer = append(aBuffer, '"[' + sDeliveryAddressDetail + ']"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_ALIGN_LT));
    aBuffer = append(aBuffer, '"' + sDeliveryAddress + '"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_NORMAL));
    aBuffer = append(aBuffer, '"' + sCustomerPhone + '"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
    aBuffer = append(aBuffer, '"' + sCustomerAddress + '"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_2HEIGHT));
    aBuffer = append(aBuffer, '"' + sBillNumber + '"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
    if (sInquiry) {
      aBuffer = append(aBuffer, '"사장님께 요청사항: "');
      aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
      aBuffer = append(aBuffer, '"' + filterEmoticon(sInquiry) + '"');
      aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    }
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_NORMAL));
  }

  return aBuffer;
};

const addFooter = async (oOrderData: any) => {
  let aBuffer: any = [];
  aBuffer = append(aBuffer, '"------------------------------------------"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_ALIGN_CT));
  aBuffer = append(aBuffer, '"고객님,"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, '"배달 주문은 호텔에서 관여하지 않습니다."');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, '"문의는 매장/노크노크 고객센터로 연락주세요"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));

  aBuffer = append(aBuffer, "\"카카오톡에서 '노크노크'를 검색해주세요\"");
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));

  if (oOrderData.child.room_tip > 0) {
    aBuffer = append(aBuffer, '"객실관리팁은 쓰레기 분리수거를 위한"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    aBuffer = append(aBuffer, '"최소한의 비용으로 음식점과"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    aBuffer = append(aBuffer, '"무관하게 청구됩니다."');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  }

  //aBuffer = append(aBuffer, '"(노크노크 고객센터)"');
  //aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));

  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_CR));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.PAPER_PART_CUT_TWO));

  return aBuffer;
};

const addProductContent = async (
  oOrderData: any,
  oPayments?: any,
  bHideMenuContent?: boolean
) => {
  let aBuffer: any = [];
  let aPrdDetails: any = [];

  if (oOrderData && oOrderData.child) {
    if (oOrderData.child.detail && oOrderData.child.detail.length > 0) {
      for (const oPrd of oOrderData.child.detail) {
        aPrdDetails.push(oPrd);
      }
    }
  }

  // Header
  var sOrderHeaderList = columnify(
    [{ prdname: "상품명", price: "단가", count: "수량", amount: "금액" }],
    {
      truncate: false,
      showHeaders: false,
      config: {
        prdname: { minWidth: 20, maxWidth: 20, showHeaders: false },
        price: { minWidth: 7, maxWidth: 7, align: "right", showHeaders: false },
        count: { minWidth: 4, maxWidth: 4, align: "right", showHeaders: false },
        amount: {
          minWidth: 8,
          maxWidth: 8,
          align: "right",
          showHeaders: false,
        },
      },
    }
  );

  let oProductItem: {
    prdname?: string;
    price?: string;
    count?: string;
    amount?: string;
  } = {};

  var sOrderDataList = "";
  if (aPrdDetails && aPrdDetails.length > 0) {
    for (const orderDetails of aPrdDetails) {
      oProductItem = {};
      oProductItem["prdname"] = filterEmoticon(orderDetails.product_name);
      oProductItem["price"] = orderDetails.product_price.toLocaleString();
      oProductItem["count"] = orderDetails.product_quantity.toString();
      oProductItem["amount"] = (
        orderDetails.product_price * (orderDetails.product_quantity || 0)
      ).toLocaleString();
      sOrderDataList += columnifyPrd([oProductItem]);

      for (let j = 0; j < (orderDetails.set_prd_type_list?.length ?? 0); j++) {
        oProductItem = {};
        oProductItem["prdname"] = filterEmoticon(
          orderDetails.set_prd_type_list![j].set_prd_type_name
        );
        oProductItem["amount"] = "";
        sOrderDataList += columnifySetPrd([oProductItem]);

        if (orderDetails.set_prd_type_list![j].set_product) {
          for (const oSetPrd of orderDetails.set_prd_type_list![j]
            .set_product) {
            oProductItem = {};
            oProductItem["prdname"] =
              "-" +
              receiptFormat.receipt_option_mark +
              filterEmoticon(oSetPrd.product_name);
            oProductItem["price"] = oSetPrd.product_price.toLocaleString();
            oProductItem["count"] = orderDetails.product_quantity.toString();
            oProductItem["amount"] =
              oSetPrd.product_total_amount.toLocaleString();
            sOrderDataList += columnifyPrd([oProductItem]);

            if (oSetPrd && oSetPrd.options) {
              for (const oSetOptions of oSetPrd.options) {
                oProductItem = {};
                oProductItem["prdname"] =
                  "[..]+ " +
                  filterEmoticon(oSetOptions.option_type_name) +
                  " | " +
                  filterEmoticon(oSetOptions.option_name);
                oProductItem["amount"] = (
                  oSetOptions.option_price * orderDetails.product_quantity || 0
                ).toLocaleString();
                sOrderDataList += columnifySetPrd([oProductItem]);
              }
            }
          }
        }
        /*
        oProductItem = {};
        oProductItem["prdname"] = "    " + filterEmoticon(orderDetails.set_prd_type_list![j].set_prd_type_name);
        oProductItem["price"] = orderDetails.set_options![j].product_price.toLocaleString();
        oProductItem["count"] = orderDetails.set_options![j].product_quantity?.toString();
        oProductItem["amount"] = (orderDetails.set_options![j].product_price * orderDetails.set_options![j].product_quantity || 0).toLocaleString();
        aOrderProducts.push(oProductItem);

        for (let oOptions of orderDetails.set_options![j].options!) {
          oProductItem = {};
          oProductItem["prdname"] = receiptFormat.order_option_mark + filterEmoticon(oOptions.option_name);
          oProductItem["price"] = oOptions.option_price.toLocaleString();
          oProductItem["count"] = "";
          oProductItem["amount"] = (oOptions.option_price * orderDetails.product_quantity || 0).toLocaleString();

          aOrderProducts.push(oProductItem);
        }
        */
      }
      if (orderDetails.options && (orderDetails.options?.length ?? 0 > 0)) {
        for (let oOptions of orderDetails.options!) {
          oProductItem = {};
          oProductItem["prdname"] =
            "[.]+ " + filterEmoticon(oOptions.option_name);
          oProductItem["price"] = "";
          oProductItem["count"] = "";
          oProductItem["amount"] = (
            oOptions.option_price * orderDetails.product_quantity || 0
          ).toLocaleString();
          sOrderDataList += columnifyPrd([oProductItem]);
        }
      }
    }
  }

  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_ALIGN_LT));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_NORMAL));
  aBuffer = append(
    aBuffer,
    '"주문시간: ' +
      moment(oOrderData.child.created_at).format("YYYY/MM/DD HH:mm:ss") +
      '"'
  );
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  if (bHideMenuContent) {
  } else {
    aBuffer = append(aBuffer, '"' + pad("", "=", receiptWidth, "right") + '"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    aBuffer = append(aBuffer, '"' + sOrderHeaderList + '"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    aBuffer = append(aBuffer, '"' + pad("", "-", receiptWidth, "right") + '"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));

    let aLines = sOrderDataList.split("\n");
    if (aLines && aLines.length > 0) {
      for (let sLine of aLines) {
        if (sLine) {
          if (sLine.indexOf("[..]") !== -1) {
            sLine = sLine.replace("[..]", "    ");
          } else if (sLine.indexOf("[.]") !== -1) {
            sLine = sLine.replace("[.]", "   ");
          }
          aBuffer = append(aBuffer, '"' + sLine + '"');
          aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
        }
      }
    }
  }

  return aBuffer;
};

const addOrderTotalCost = async (oOrderData: any) => {
  let aBuffer: any = [];

  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_ALIGN_LT));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_NORMAL));
  aBuffer = append(aBuffer, '"' + pad("", "-", receiptWidth, "right") + '"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));

  let aTotalHeaderData: any = [];
  let iPaymentCardAmount = 0;
  let iOrderQuantity = 0;
  let iOrderTotalAmount = 0;
  let bAddDivider = false;
  let iTax = 0;

  let iComDiscount = 0;
  let iStoreDiscount = 0;
  let iDeliveryCost = 0;

  //console.log('oOrderData', oOrderData);

  let oPaidPayments: any = oOrderData.payment;
  if (oPaidPayments && oPaidPayments.length > 0) {
    for (const oPayData of oPaidPayments) {
      if (oPayData.pay_type === "CARD" && oPayData.tran_type === "APPROVAL") {
        iPaymentCardAmount = iPaymentCardAmount + oPayData.amount;
        bAddDivider = true;
        iTax = iTax + oPayData.vat_amount;
        iOrderTotalAmount = iOrderTotalAmount + oPayData.amount;
      }
    }
    iOrderTotalAmount = iOrderTotalAmount - iTax;
  }
  //console.log('iOrderTotalAmount', iOrderTotalAmount);
  //console.log('iPaymentCardAmount', iPaymentCardAmount);
  //console.log('iTax', iTax);

  if (oOrderData && oOrderData.child) {
    if (oOrderData.child.detail && oOrderData.child.detail.length > 0) {
      for (const oPrd of oOrderData.child.detail) {
        iOrderQuantity = iOrderQuantity + oPrd.product_quantity;
      }
    }
    iComDiscount = iComDiscount + oOrderData.child.com_discount_amount;
    iStoreDiscount = iStoreDiscount + oOrderData.child.store_discount_amount;
    iDeliveryCost = iDeliveryCost + oOrderData.child.delivery_tip;
  }

  let roomTip = oOrderData.child.room_tip;
  aTotalHeaderData.push({
    prdname: "배달팁",
    amount: "",
    price: iDeliveryCost.toLocaleString(),
  });
  if (roomTip !== undefined && roomTip > 0) {
    aTotalHeaderData.push({
      prdname: "객실관리팁",
      amount: "",
      price: roomTip.toLocaleString(),
    });
  }

  // 할인
  if (iComDiscount) {
    aTotalHeaderData.push({
      prdname: "노크노크 부담 할인",
      amount: "",
      price: "-" + iComDiscount.toLocaleString(),
    });
  }
  if (iStoreDiscount) {
    aTotalHeaderData.push({
      prdname: "매장 부담 할인",
      amount: "",
      price: "-" + iStoreDiscount.toLocaleString(),
    });
  }

  let sTotalCostHeader = columnify(aTotalHeaderData, {
    truncate: false,
    showHeaders: false,
    config: {
      prdname: { minWidth: 28, maxWidth: 28, showHeaders: false },
      amount: { minWidth: 4, maxWidth: 4, align: "right", showHeaders: false },
      price: { minWidth: 8, maxWidth: 8, align: "right", showHeaders: false },
    },
  });

  let aLines = sTotalCostHeader.split("\n");
  if (aLines && aLines.length > 0) {
    for (const sLine of aLines) {
      if (sLine) {
        aBuffer = append(aBuffer, '"' + sLine + '"');
        aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
      }
    }
  }

  let aActualPayment = [];

  //aActualPayment.push({ prdname: "합계금액", amount: iOrderQuantity.toString(), price: iOrderTotalAmount.toLocaleString() });
  //aActualPayment.push({ prdname: "부가세", amount: "", price: iTax.toLocaleString() });
  //aActualPayment.push({ prdname: "", amount: "", price: "" });
  aActualPayment.push({
    prdname: "결제 금액 (선결제 완료)",
    amount: "",
    price: iPaymentCardAmount.toLocaleString(),
  });

  let sActualPaymentTotal = columnify(aActualPayment, {
    truncate: false,
    showHeaders: false,
    config: {
      prdname: { minWidth: 28, maxWidth: 28, showHeaders: false },
      amount: { minWidth: 4, maxWidth: 4, align: "right", showHeaders: false },
      price: { minWidth: 8, maxWidth: 8, align: "right", showHeaders: false },
    },
  });

  let aActualPaymentLines = sActualPaymentTotal.split("\n");
  if (aActualPaymentLines && aActualPaymentLines.length > 0) {
    aBuffer = append(aBuffer, '"' + pad("", "-", receiptWidth, "right") + '"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    for (const sLine of aActualPaymentLines) {
      if (sLine) {
        if (sLine.indexOf("선결제") !== -1) {
          aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_2HEIGHT));
          aBuffer = append(aBuffer, '"' + sLine + '"');
          aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
          aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_NORMAL));
        } else {
          aBuffer = append(aBuffer, '"' + sLine + '"');
          aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
        }
      }
    }
  }
  aBuffer = append(aBuffer, '"' + pad("", "=", receiptWidth, "right") + '"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));

  return aBuffer;
};

const addStoreInfo = async (oOrderData: any) => {
  let aBuffer: any = [];

  let sStoreName = "";
  let sStoreAddress = "";
  let sStorePhoneNumber = "";
  let bIsForAdult = false;

  if (oOrderData && oOrderData.child) {
    sStoreName = `상호: ${oOrderData.store_name}`;

    if (oOrderData.child.store_address1) {
      sStoreAddress = `주소: ${oOrderData.child.store_address1}`;
    }

    if (oOrderData.child.store_phone_number) {
      sStorePhoneNumber = `매장번호: ${oOrderData.child.store_phone_number}`;
    }

    if (oOrderData.child && oOrderData.child.is_for_adult === 1) {
      bIsForAdult = true;
    }
  }

  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_ALIGN_LT));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_NORMAL));
  aBuffer = append(aBuffer, '"' + sStoreName + '"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, '"' + sStoreAddress + '"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, '"' + sStorePhoneNumber + '"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));

  if (bIsForAdult) {
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_ALIGN_CT));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_2HEIGHT));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    //aBuffer = append(aBuffer, await generateFor19Info());
    aBuffer = append(aBuffer, '"(19) 주류 상품이 포함되어있어 신분증"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
    aBuffer = append(aBuffer, '"검사가 필요합니다"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
    //aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    //aBuffer = append(aBuffer, '" 주류 상품이 포함되어있어 신분증 검사가 필요합니다"');
    //aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    //aBuffer = append(aBuffer, '"필요합니다"');
    //aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    //aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_NORMAL));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_ALIGN_LT));
  }

  return aBuffer;
};

const makeQrCode = async (sData: string, extraSettings?: any) => {
  let aBuffer: any = [];
  let oConfig: any = PrinterConfig;
  //let sReturn: string = "";
  /*
  const append = (appendBuffer: any) => {
    if (mBuffer) {
      mBuffer = Buffer.concat([mBuffer, appendBuffer]);
    } else {
      mBuffer = appendBuffer;
    }
  }
  */

  let settings: any = {
    model: 2,
    cellSize: 3,
    correction: "M",
    ...extraSettings,
  };
  aBuffer = append(aBuffer, toHexString(oConfig.HW_INIT));
  aBuffer = append(aBuffer, toHexString(oConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, toHexString(oConfig.TXT_ALIGN_CT));

  // [Name] Select the QR code model
  // [Code] 1D 28 6B 04 00 31 41 n1 n2
  // n1
  // [49 x31, model 1]
  // [50 x32, model 2]
  // [51 x33, micro qr code]
  // n2 = 0
  // https://reference.epson-biz.com/modules/ref_escpos/index.php?content_id=140
  if (settings.model === 1) {
    aBuffer = append(aBuffer, toHexString(oConfig.QRCODE_MODEL1));
  } else if (settings.model === 3) {
    aBuffer = append(aBuffer, toHexString(oConfig.QRCODE_MODEL3));
  } else {
    aBuffer = append(aBuffer, toHexString(oConfig.QRCODE_MODEL2));
  }

  // [Name]: Set the size of module
  // 1D 28 6B 03 00 31 43 n
  // n depends on the printer
  // https://reference.epson-biz.com/modules/ref_escpos/index.php?content_id=141
  const size = "QRCODE_CELLSIZE_".concat(settings.cellSize.toString());
  aBuffer = append(aBuffer, toHexString(oConfig[size]));

  // [Name] Select the error correction level
  // 1D 28 6B 03 00 31 45 n
  // n
  // [48 x30 -> 7%]
  // [49 x31-> 15%]
  // [50 x32 -> 25%]
  // [51 x33 -> 30%]
  // https://reference.epson-biz.com/modules/ref_escpos/index.php?content_id=142
  const correction = "QRCODE_CORRECTION_".concat(
    settings.correction.toUpperCase()
  );
  aBuffer = append(aBuffer, toHexString(oConfig[correction]));

  // [Name] Store the data in the symbol storage area
  // 1D 28  6B pL pH 31 50 30 d1...dk
  // https://reference.epson-biz.com/modules/ref_escpos/index.php?content_id=143
  const s: any = sData.length + 3;
  const lsb: any = parseInt((s % 256).toString());
  const msb: any = parseInt((s / 256).toString());
  aBuffer = append(
    aBuffer,
    toHexString(Buffer.from([0x1d, 0x28, 0x6b, lsb, msb, 0x31, 0x50, 0x30]))
  );
  aBuffer = append(aBuffer, toHexString(Buffer.from(sData)));

  // [Name] Print the symbol data in the symbol storage area
  // 1D 28 6B 03 00 31 51 m
  // https://reference.epson-biz.com/modules/ref_escpos/index.php?content_id=144
  aBuffer = append(aBuffer, toHexString(oConfig.QRCODE_PRINT));

  //if (aBuffer) {
  //sReturn = aBuffer.join("\n");
  //}

  return aBuffer;
};

const generateHeaderLogo = async () => {
  let aBuffer: any = [];

  try {
    aBuffer = await ESCPOSImage.load(PRINTER_KNOCKKNOCK_LOGO_IMAGE).then(
      (logo: any) => {
        let oPrintBuffer = new PrintBuffer();
        oPrintBuffer.image(logo, BitmapDensity.D24);
        let sBuffer = oPrintBuffer.toHextString();
        return sBuffer;
      }
    );
  } catch (error) {
    throw error;
  }

  console.log("generateHeaderLogo buff  ", aBuffer);
  return aBuffer;
};

const generateFor19Info = async () => {
  let aBuffer: any = [];

  try {
    aBuffer = await ESCPOSImage.load(PRINTER_ORDER_ADULT_IMAGE).then(
      (logo: any) => {
        let oPrintBuffer = new PrintBuffer();
        oPrintBuffer.image(logo, BitmapDensity.D24);
        let sBuffer = oPrintBuffer.toHextString();
        return sBuffer;
      }
    );
  } catch (error) {
    throw error;
  }

  return aBuffer;
};

const generateQrCodeImg = async (sUrl: string) => {
  let aBuffer: any = [];

  try {
    const BufferQRCode: any = await QRCode.toDataURL(sUrl, { width: 150 });
    var escpos = window?.Neodynamic?.JSESCPOSBuilder;
    if (escpos) {
      var doc = new escpos.Document();
      await escpos.ESCPOSImage.load(BufferQRCode).then((logo: any) => {
        //console.log('logo', logo);

        // logo image loaded, create ESC/POS commands

        var escposCommands = doc
          .align(escpos.TextAlignment.Center)
          .raster(logo, "NORMAL")
          .generateUInt8Array();

        //console.log('escposCommands', window?.toHextString(escposCommands));
        aBuffer = append(aBuffer, window?.toHextString(escposCommands));
      });
    }

    //const response = await axios.get(BufferQRCode, { responseType: 'arraybuffer' })
    //const buffer = Buffer.from(response.data, 'binary')
    //console.log('buffer', JSON.stringify(response.data));

    /*
    aBuffer = await ESCPOSImage.load(BufferQRCode).then((logo: any) => {
      let oPrintBuffer = new PrintBuffer();
      oPrintBuffer.image(logo, BitmapDensity.D24);
      let sBuffer = oPrintBuffer.toHextString();
      return sBuffer;
    });
    */

    ///const buff = getImageBuffer(120, 120, aBase64ToBuffer);
    //aBuffer = buff;
  } catch (error) {
    throw error;
  }

  //console.log('generateQrCodeImg buff  ', aBuffer);
  return aBuffer;
};

const generateQrCodeText = async (sUrl: string) => {
  let aBuffer: any = [];

  try {
    let oQrCodePrintBuffer = new PrintBuffer();
    oQrCodePrintBuffer.qrCode(sUrl, new BarcodeQROptions(QRLevel.L, 6));
    let sBufferQrCode = oQrCodePrintBuffer.toHextString();
    aBuffer = sBufferQrCode;
  } catch (error) {
    throw error;
  }

  console.log("generateQrCode generateQrCodeText  ", aBuffer);
  return aBuffer;
};

const addQrInfo = async (oOrderData: any, sQrCodeUrl: string) => {
  let aBuffer: any = [];
  let sPickupLocation = "";

  if (oOrderData && oOrderData.child) {
    sPickupLocation = oOrderData.child.pickup_name;
  }

  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_ALIGN_CT));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_2HEIGHT));
  aBuffer = append(aBuffer, '"(배달위치)"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, '"' + sPickupLocation + '"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, await generateQrCodeImg(sQrCodeUrl));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_2HEIGHT));
  //aBuffer = append(aBuffer, '"기사님, 픽업 후 배달완료 후 QR 을 찍고"');
  //aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  //aBuffer = append(aBuffer, '" 완료버튼을 눌러주시면 50포인트를 드려요!"');
  //aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));

  return aBuffer;
};

const addKitchenHeader = async (oOrderData: any) => {
  let aBuffer: any = [];
  let sBillNumber = "주문번호: ";
  let sInquiry = "";

  if (oOrderData && oOrderData.child) {
    if (oOrderData.child.inquiry) {
      sInquiry = oOrderData.child.inquiry;
    }
    if (oOrderData && oOrderData.child) {
      sBillNumber += oOrderData.child.bill_number;
    }
  }

  aBuffer = append(aBuffer, toHexString(PrinterConfig.HW_INIT));
  if (
    oOrderData &&
    oOrderData.child &&
    oOrderData.child.order_service === ORDER_SERVICE.KNOCKKNOCK_ORDER
  ) {
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_FONT_B));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_ALIGN_CT));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_2HEIGHT));
    aBuffer = append(aBuffer, '"KNOCK KNOCK"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
    aBuffer = append(aBuffer, '"주문서"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_ALIGN_LT));
    aBuffer = append(aBuffer, '"' + sBillNumber + '"');
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_NORMAL));
    aBuffer = append(
      aBuffer,
      '"주문시간: ' +
        moment(oOrderData.child.created_at).format("YYYY/MM/DD HH:mm:ss") +
        '"'
    );
    aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_2HEIGHT));
    aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    if (sInquiry) {
      aBuffer = append(aBuffer, '"요청사항: ' + filterEmoticon(sInquiry) + '"');
      aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
    }
  }

  var sOrderHeaderList = columnify([{ prdname: "메뉴명", count: "수량" }], {
    truncate: false,
    showHeaders: false,
    config: {
      prdname: { minWidth: 30, maxWidth: 30, showHeaders: false },
      count: { minWidth: 10, maxWidth: 10, align: "right", showHeaders: false },
    },
  });

  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_NORMAL));
  aBuffer = append(aBuffer, '"' + pad("", "=", receiptWidth, "right") + '"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, '"' + sOrderHeaderList + '"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, '"' + pad("", "-", receiptWidth, "right") + '"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));

  return aBuffer;
};

const addKitchenProductInfo = async (oOrderData: any) => {
  let aBuffer: any = [];
  let aPrdDetails: any = [];
  let aOrderProducts = [];

  if (oOrderData && oOrderData.child) {
    if (oOrderData.child.detail && oOrderData.child.detail.length > 0) {
      for (const oPrd of oOrderData.child.detail) {
        aPrdDetails.push(oPrd);
      }
    }
  }

  let oProductItem: {
    prdname?: string;
    count?: string;
  } = {};

  var sOrderDataList = "";
  if (aPrdDetails && aPrdDetails.length > 0) {
    for (const orderDetails of aPrdDetails) {
      oProductItem = {};
      oProductItem["prdname"] = filterEmoticon(orderDetails.product_name);
      oProductItem["count"] = orderDetails.product_quantity.toString();
      sOrderDataList += columnifyKitchenPrd([oProductItem]);

      for (let j = 0; j < (orderDetails.set_prd_type_list?.length ?? 0); j++) {
        if (orderDetails.set_prd_type_list![j].set_product) {
          for (const oSetPrd of orderDetails.set_prd_type_list![j]
            .set_product) {
            oProductItem = {};
            oProductItem["prdname"] =
              "-" +
              receiptFormat.receipt_option_mark +
              filterEmoticon(oSetPrd.product_name);
            oProductItem["count"] = orderDetails.product_quantity.toString();
            sOrderDataList += columnifyKitchenPrd([oProductItem]);

            if (oSetPrd && oSetPrd.options) {
              for (const oSetOptions of oSetPrd.options) {
                oProductItem = {};
                oProductItem["prdname"] =
                  "[..]+ " +
                  filterEmoticon(oSetOptions.option_type_name) +
                  " | " +
                  filterEmoticon(oSetOptions.option_name);
                oProductItem["count"] = "";
                sOrderDataList += columnifyKitchenPrd([oProductItem]);
              }
            }
          }
        }
        /*
        for (let j = 0; j < (orderDetails.set_options?.length ?? 0); j++) {
          oProductItem = {};
          oProductItem["prdname"] = "    " + filterEmoticon(orderDetails.set_options![j].product_name);
          oProductItem["count"] = orderDetails.set_options![j].product_quantity?.toString();
          aOrderProducts.push(oProductItem);

          for (let oOptions of orderDetails.set_options![j].options!) {
            oProductItem = {};
            oProductItem["prdname"] = receiptFormat.order_option_mark + filterEmoticon(oOptions.option_name);
            oProductItem["count"] = "";
            aOrderProducts.push(oProductItem);
          }
        }
        */
      }

      if (orderDetails.options && (orderDetails.options?.length ?? 0 > 0)) {
        for (let oOptions of orderDetails.options!) {
          oProductItem = {};
          oProductItem["prdname"] =
            "[.]+ " + filterEmoticon(oOptions.option_name);
          oProductItem["count"] = "";
          sOrderDataList += columnifyKitchenPrd([oProductItem]);
        }
      }
    }
  }

  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_2HEIGHT));
  let aLines = sOrderDataList.split("\n");
  if (aLines && aLines.length > 0) {
    for (let sLine of aLines) {
      if (sLine) {
        if (sLine.indexOf("[..]") !== -1) {
          sLine = sLine.replace("[..]", "    ");
        } else if (sLine.indexOf("[.]") !== -1) {
          sLine = sLine.replace("[.]", "   ");
        }
        aBuffer = append(aBuffer, '"' + sLine + '"');
        aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
      }
    }
  }
  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_NORMAL));
  aBuffer = append(aBuffer, '"' + pad("", "-", receiptWidth, "right") + '"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_2HEIGHT));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_BOLD_ON));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, '"호텔 배달입니다. 수저 꼭 보내주세요!!!"');
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));

  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF_CR));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.TXT_NORMAL));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_CR));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));
  aBuffer = append(aBuffer, toHexString(PrinterConfig.CTL_LF));

  aBuffer = append(aBuffer, toHexString(PrinterConfig.PAPER_PART_CUT_TWO));

  return aBuffer;
};

const ReceiptController = {
  makeCustomerReceipt: async (
    oOrderData: any,
    sQrCodeUrl?: any,
    bHideMenuContent?: boolean
  ) => {
    let aBuffer: any = [];
    let sReceipt = "";
    aBuffer = aBuffer.concat(await addHeader(oOrderData));
    aBuffer = aBuffer.concat(await addProductContent(oOrderData));
    aBuffer = aBuffer.concat(await addOrderTotalCost(oOrderData));
    aBuffer = aBuffer.concat(await addStoreInfo(oOrderData));
    //aBuffer = aBuffer.concat(await makeQrCode(sQrCodeUrl, { cellSize: 6 }));
    //aBuffer = aBuffer.concat(await generateQrCodeImg(sQrCodeUrl));
    //aBuffer = aBuffer.concat(toHexString(PrinterConfig.TXT_ALIGN_LT));
    aBuffer = aBuffer.concat(await addQrInfo(oOrderData, sQrCodeUrl));
    aBuffer = aBuffer.concat(await addFooter(oOrderData));

    if (aBuffer) {
      sReceipt = aBuffer.join("\n");
    }

    return sReceipt;
  },

  /*
  makeCustomerReceiptQrMode: async (oOrderData: any, sQrCodeUrl?: any, bHideMenuContent?: boolean) => {
    let aBuffer: any = [];
    let sReceipt = "";
    aBuffer = aBuffer.concat(await addHeader(oOrderData));
    aBuffer = aBuffer.concat(await addProductContent(oOrderData));
    aBuffer = aBuffer.concat(await addOrderTotalCost(oOrderData));
    aBuffer = aBuffer.concat(await addStoreInfo(oOrderData));
    aBuffer = aBuffer.concat(toHexString(PrinterConfig.TXT_ALIGN_CT));
    aBuffer = aBuffer.concat(toHexString(PrinterConfig.CTL_CR));
    aBuffer = aBuffer.concat(toHexString(PrinterConfig.CTL_LF));
    //aBuffer = aBuffer.concat(await generateQrCodeText(sQrCodeUrl));
    aBuffer = aBuffer.concat(toHexString(PrinterConfig.TXT_ALIGN_LT));
    aBuffer = aBuffer.concat(await addQrInfo(oOrderData));
    aBuffer = aBuffer.concat(await addFooter(oOrderData));

    if (aBuffer) {
      sReceipt = aBuffer.join("\n");
    }

    return sReceipt;
  },
  */

  makeKitchenReceipt: async (oOrderData: any) => {
    let aBuffer: any = [];
    let sReceipt = "";
    aBuffer = aBuffer.concat(await addKitchenHeader(oOrderData));
    aBuffer = aBuffer.concat(await addKitchenProductInfo(oOrderData));

    if (aBuffer) {
      sReceipt = aBuffer.join("\n");
    }

    return sReceipt;
  },

  generateQrCodeImg: async (sVal: string) => {
    generateQrCodeImg(sVal);
  },
};

export default ReceiptController;
